// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateAggregationService } from '@coa/app/core/services/date-aggregation/date-aggregation.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardGuardService implements CanActivate {

  constructor(private router: Router,
              private dateAggregationService: DateAggregationService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (route.queryParams.dateRange) {
      return true;
    }

    return this.dateAggregationService.getDefaultType(route.params.clientId)
      .pipe(
        map((dateRange) => {
          this.router.navigate(['/clients', route.params.clientId, 'dashboard'], {
            queryParams: {
              dateRange: route.queryParams.dateRange || dateRange,
            },
          });
          return false;
        }),
      );
  }
}
